import { render, staticRenderFns } from "./FormColorPicker.vue?vue&type=template&id=cbec8a0a"
import script from "./FormColorPicker.vue?vue&type=script&lang=js"
export * from "./FormColorPicker.vue?vue&type=script&lang=js"
import style0 from "./FormColorPicker.vue?vue&type=style&index=0&id=cbec8a0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports